import { createApi } from '@reduxjs/toolkit/query/react';
import { idType } from '@src/types';
import { baseQuerySample } from '@store/helpers';

export const surveyTemplateApi = createApi({
  reducerPath: 'SurveyTemplate',
  tagTypes: ['SurveyTemplate'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    createEditSurveyTemplate: builder.mutation<
      {
        id: number;
        name: string;
        description: string;
        activeIndicator: boolean;
        signatureRequiredIndicator: boolean;
        logoDocumentId: number;
      },
      {
        body: {
          id: idType;
          name: string;
          description: string;
          activeIndicator: boolean;
          signatureRequiredIndicator: boolean;
          logoDocumentId?: number;
        };
        method: string;
      }
    >({
      query: ({ body, method }) => ({
        url: `/v1/users/survey-templates${method === 'PUT' ? `/${body.id} ` : ''}`,
        method,
        body,
      }),
    }),
    createEditSurveyTemplateQuest: builder.mutation({
      query: ({ body, method }) => ({
        url: `/v1/users/templates-questions/${method === 'PUT' ? `${body.id} ` : 'create'}`,
        method,
        body,
      }),
    }),
    deleteSurveyTemplate: builder.mutation({
      query: ({ id }) => ({
        url: `/v1/users/survey-templates/${id}`,
        method: 'DELETE',
      }),
    }),

    getSurveyTemplateQuest: builder.query({
      query: ({ id, surveyId }) => ({
        url: `/v1/users/templates-questions/surveys/${surveyId}/template/${id}`,
      }),
    }),
    updateSurveyTemplateAnswer: builder.mutation({
      query: ({ surveyId, body }) => ({
        url: `/v1/users/templates-questions/answers-question/${surveyId}`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useCreateEditSurveyTemplateMutation,
  useCreateEditSurveyTemplateQuestMutation,
  useDeleteSurveyTemplateMutation,
  useLazyGetSurveyTemplateQuestQuery,
  useUpdateSurveyTemplateAnswerMutation,
} = surveyTemplateApi;
